export default __webpack_public_path__ + "static/media/many-options.fd01a6e7.svg";